import React, {
  useState,
  useContext,
  useEffect,
  useRef,
  useImperativeHandle,
} from "react"
import { useFormContext } from "react-hook-form"
import intl from "react-intl-universal"
import { NumericFormat } from "react-number-format"
import moment from "moment"

import {
  cDeadLineSlug,
  cDescritionSlug,
  cStatusFieldName,
  cStatusSlug,
  dConclusionDateSlug,
  dCreationDateSlug,
} from "../../../constans/activity-slugs"
import AuthContext from "../../../contexts/Auth"
import BoardContext from "../../../contexts/Board"
import PaineisContext from "../../../contexts/Paineis"
import { fnFormatDate, fnFormatDateFromUTC, fnFormatDateToUTC } from "../../../utils/date"
import RcmpDatePicker from "../../atoms/DatePicker"
import RcmpFormErrorMessage from "../../atoms/FormErrorMessage"
import Input from "../../atoms/Input"
import Label from "../../atoms/Label"
import Select from "../../atoms/Select"
import SwitchComponent from "../../atoms/Switch"
import RcmpTextArea from "../../atoms/TextArea"
import RcmpSelectUsers from "../../molecules/SelectUsers"
import styles from "./index.module.scss"
import MoveEllipsisIcon from "../../../assets/icons/MoveEllipsisIcon"
import { isEqual } from "../../../utils/compare"
import CalcField from "../../molecules/CalcField"
import Button from "../../atoms/Button"
import Modal from "../../molecules/Modal"
import StatesOfModals from "../../../contexts/StatesOfModals"
import ModalCalcMemory from "../../molecules/ModalCalcMemory"
import FieldsContext from "../../../contexts/Fields"

const RcmpTextField = React.forwardRef((props, ref) => {
  const { cFieldName, register, bIsDraggable, bIsDisabled } = props
  return (
    <Input
      bIsDraggable={bIsDraggable}
      disabled={bIsDisabled}
      ref={ref}
      isFullWidth
      {...register(cFieldName)}
      {...props}
    />
  )
})
const RcmpMemoTextField = React.memo(RcmpTextField)

const RcmpDateField = React.forwardRef((props, ref) => {
  const {
    required,
    setValue,
    watch,
    cFieldName,
    register,
    bIsDraggable,
    disabled,
    oFieldValue,
    bIsEditModel,
    ...oRest
  } = props
  const { oUser } = useContext(AuthContext)
  const cUserTimeZone = oUser?.data?.user_ctimezone

  return (
    <RcmpDatePicker
      bIsDraggable={bIsDraggable}
      ref={ref}
      defaultValue={oFieldValue?.opfv_cvalue}
      {...register(cFieldName)}
      {...oRest}
      disabled={disabled || bIsEditModel}
      onChange={(e) => {
        const bIsSameDate =
          fnFormatDate(
            oFieldValue?.opfv_cvalue,
            "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]",
            false,
            cUserTimeZone,
            "YYYY-MM-DD HH:mm",
          ) ===
          fnFormatDate(
            e,
            "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]",
            false,
            cUserTimeZone,
            "YYYY-MM-DD HH:mm",
          )
        setValue(
          cFieldName,
          fnFormatDate(
            e,
            "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]",
            false,
            cUserTimeZone,
            "YYYY-MM-DD HH:mm",
          ),
          { shouldDirty: !bIsSameDate },
        )
      }}
    />
  )
})

const RcmpCreationDateField = React.forwardRef((props, ref) => {
  const {
    ombf_brequired,
    cFieldName,
    bIsEdit,
    bIsEditModel,
    watch,
    cLabel,
    setValue,
    useFormMethods,
    oFieldValue,
    bIsDraggable,
    ...rest
  } = props
  const { oUser } = useContext(AuthContext)
  const cUserTimeZone = oUser?.data?.user_ctimezone
  // if bIsEditModel is true, the field is in edit mode, so the field is disabled and null
  const dCreationDate = bIsEdit
    ? fnFormatDate(watch(cFieldName), "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]")
    : fnFormatDate(moment.utc(), "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]", true, cUserTimeZone)
  const oFieldValueWithCreate = {
    opfv_cvalue: bIsEditModel ? null : dCreationDate || watch(cFieldName),
  }

  return (
    <div className={styles.datesContainer}>
      <RcmpDateField
        ref={ref}
        label={cLabel}
        required={false}
        cFieldName={cFieldName}
        oFieldValue={oFieldValueWithCreate}
        disabled={true}
        bIsDraggable={bIsDraggable}
        {...useFormMethods}
        {...rest}
      />
    </div>
  )
})

const RcmpConclusionDateField = React.forwardRef((props, ref) => {
  const {
    watch,
    cFieldName,
    cUserTimeZone,
    cStatusFieldName,
    setValue,
    required,
    cLabel,
    useFormMethods,
    bIsDraggable = true,
    bIsEditModel,
    oFieldValue,
    ...rest
  } = props

  // const [oFieldValueWithConclusion, fnOFieldValue] = useState(oFieldValue)
  const { oUser } = useContext(AuthContext)
  const { oCurrentPanel } = useContext(PaineisContext)
  const { oCurrentBoard } = useContext(BoardContext)

  const bUserIsAdmin = oUser?.data?.bIsAdmin
  const bCanEdit =
    oCurrentPanel?.bIsResponsible || oCurrentBoard?.bIsResponsible || bUserIsAdmin

  if (watch(cStatusFieldName) && watch(cFieldName)) {
    setValue(
      "conclusionDate",
      fnFormatDate(watch(cFieldName), "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"),
    )
  }
  
  const oFieldValueWithConclusion = {
    opfv_cvalue:
      watch(cStatusFieldName) && watch(cFieldName) && !bIsEditModel
        ? fnFormatDate(watch(cFieldName), "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]")
        : null,
  }

  // useEffect(() => {
  //   console.log("watch(cFieldName)", watch(cFieldName)?.length);
  //   // console.log("watch(cStatusFieldName)", watch(cStatusFieldName));
  //   if (watch(cStatusFieldName) === undefined) return

  //   // USE THIS WHEN DATE COMPONENT DEFAULTVALUE CAN BE SET
  //   // if (watch(cStatusFieldName) && (!watch(cFieldName) || watch(cFieldName).length == 0)) {
  //   //   const dToday = fnFormatDate(new Date(), "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]")
  //   //   fnOFieldValue((prev) => ({ ...prev, opfv_cvalue: dToday }))
  //   //   setValue("conclusionDate", dToday)
  //   //   setValue(cFieldName, dToday)
  //   // }

  //   // if (watch(cStatusFieldName) === false) {
  //   //   fnOFieldValue((prev) => ({ ...prev, opfv_cvalue: "" }))
  //   //   setValue("conclusionDate", "")
  //   //   setValue(cFieldName, "")
  //   // }
  // }, [watch(cStatusFieldName), watch(cFieldName)])

  return (
    <div className={styles.datesContainer}>
      <RcmpDateField
        ref={ref}
        label={cLabel}
        required={required}
        cFieldName={cFieldName}
        disabled={!watch(cStatusFieldName) || !bCanEdit}
        oFieldValue={oFieldValueWithConclusion}
        {...useFormMethods}
        bIsDraggable={bIsDraggable}
        bIsEditModel={bIsEditModel}
        {...rest}
      />
    </div>
  )
})

const RcmpSelectionField = React.forwardRef((props, ref) => {
  const {
    setValue,
    cFieldName,
    register,
    watch,
    options,
    opvf_opfd_nid,
    oFieldValue,
    bIsDraggable,
    bIsDisabled,
    getValues,
    ...oRest
  } = props

  const aFormatedOptions = options
    ?.filter((option) => option.op_panel_active)
    .map((oOption) => {
      return {
        ...oOption,
        label: oOption?.opfs_coption_name,
        value: oOption?.opfs_nid,
      }
    })

  const oOption = oFieldValue?.selected_option
  const oDefaultValue = oOption
    ? { label: oOption?.opfs_coption_name, value: oOption?.opfs_nid }
    : null

  //filter aFormatedOptions to check if the default value is in the options, if not, add it

  if (oDefaultValue) {
    const bIsOptionInOptions = aFormatedOptions?.find(
      (oOption) => oOption?.value === oDefaultValue?.value,
    )
    if (!bIsOptionInOptions) {
      aFormatedOptions.push(oDefaultValue)
    }
  }
  return (
    <Select
      ref={ref}
      options={aFormatedOptions}
      defaultValue={oDefaultValue}
      bIsDraggable={bIsDraggable}
      disabled={bIsDisabled}
      {...register(cFieldName)}
      onSelect={(cSelectedValue) => {
        const bIsDirty = isEqual(cSelectedValue, oDefaultValue)
        setValue(cFieldName, cSelectedValue?.value, { shouldDirty: !bIsDirty })
      }}
      {...oRest}
    />
  )
})

const RcmpPeoplesField = React.forwardRef((props, ref) => {
  const {
    setValue,
    cFieldName,
    register,
    watch,
    opvf_opfd_nid,
    options,
    oFieldValue,
    bIsDraggable,
    bIsDisabled,
    getValues,
    ...oRest
  } = props
  const aDefaultValue = oFieldValue?.opfv_cvalue?.length
    ? oFieldValue?.opfv_cvalue?.map((oUser) => ({
        value: oUser?.user_nid,
        label: oUser?.user_cname,
      }))
    : []

  function fnHandleSetValues(aUsers) {
    if (!aUsers?.length) {
      setValue(cFieldName, [])
      return
    }
    const bIsDirty = isEqual(aUsers, aDefaultValue)
    setValue(
      cFieldName,
      aUsers?.map((oUser) => oUser?.value),
      { shouldDirty: !bIsDirty },
    )
    // return (
    //   <RcmpSelectUsers
    //     bIsDraggable={true}
    //     disabled={bIsDisabled}
    //     ref={ref}
    //     multiSelect
    //     isFullWidth
    //     searchable
    //     defaultValue={aDefaultValue}
    //     onSelect={(fnHandleSetValues)}
    //     {...oRest}
    //   />
    // )
  }

  return (
    <RcmpSelectUsers
      bIsDraggable={bIsDraggable}
      disabled={bIsDisabled}
      ref={ref}
      multiSelect
      isFullWidth
      searchable
      defaultValue={aDefaultValue}
      onSelect={fnHandleSetValues}
      {...oRest}
    />
  )
})

const ElInputNumber = (props) => {
  const {
    opfd_cprefix,
    prefix,
    opfd_csuffix,
    suffix,
    bIsDraggable = false,
    bIsDisabled,
  } = props

  const elPrefix = opfd_cprefix || prefix ? <span>{opfd_cprefix || prefix}</span> : null
  const elSufix = opfd_csuffix || suffix ? <span>{opfd_csuffix || suffix}</span> : null

  return (
    <Input
      isFullWidth
      disabled={bIsDisabled}
      iconLeft={elPrefix}
      iconRight={elSufix}
      bIsDraggable={bIsDraggable}
      {...props}
    />
  )
}
const RcmpNumberField = React.forwardRef((props, ref) => {
  const {
    cFieldName,
    setValue,
    getValues,
    register,
    opfd_cprefix,
    prefix,
    opfd_csuffix,
    suffix,
    opfd_nprecision,
    bIsDraggable = false,
    bIsDisabled,
    currentField,
    bIsEditModel,
    ...oRest
  } = props

  const opfd_nmin_limit = currentField?.opfd_nmin_limit
  const opfd_nmin_ideal = currentField?.opfd_nmin_ideal
  const opfd_nmax_ideal = currentField?.opfd_nmax_ideal
  const opfd_nmax_limit = currentField?.opfd_nmax_limit


  const inputRef = useRef(null)
  useImperativeHandle(ref, () => ({
    focus: () => {
      inputRef.current.focus()
    },
  }))

  const [rangeMessage, fnSetRangeMessage] = useState("")

  function handleCheckRange(value, e) {
    if (!opfd_nmax_ideal || !opfd_nmin_ideal || !opfd_nmax_limit || !opfd_nmin_limit)
      return
    //verifica se value é maior que o opfd_nmin_limit
    let minLimit = Number(opfd_nmin_limit.replace(",", "."))
    let minIdeal = Number(opfd_nmin_ideal.replace(",", "."))
    let maxIdeal = Number(opfd_nmax_ideal.replace(",", "."))
    let maxLimit = Number(opfd_nmax_limit.replace(",", "."))

    if (oRest.ombf_brequired === "NOT_REQUIRED" && !value) {
      fnSetRangeMessage("")
      return
    }

    if (minLimit && Number(value.replace(",", ".")) < minLimit) {
      fnSetRangeMessage("Insira um valor entre o Limite Mínimo e o Limite Máximo")
      inputRef.current?.currentTarget.focus
      return
    }
    if (
      minLimit &&
      minIdeal &&
      Number(value.replace(",", ".")) >= minLimit &&
      Number(value.replace(",", ".")) <= minIdeal
    ) {
      fnSetRangeMessage(
        "Atenção: O número digitado está entre o Limite Mínimo e o Mínimo Ideal",
      )
      return
    }
    if (
      minIdeal &&
      maxIdeal &&
      Number(value.replace(",", ".")) > minIdeal &&
      Number(value.replace(",", ".")) < maxIdeal
    ) {
      fnSetRangeMessage("")
      return
    }
    if (
      maxIdeal &&
      Number(value.replace(",", ".")) >= maxIdeal &&
      Number(value.replace(",", ".")) <= maxLimit
    ) {
      fnSetRangeMessage(
        "Atenção: O número digitado está entre o Máximo Ideal  e o Limite Máximo",
      )
      return
    }
    if (maxLimit && Number(value.replace(",", ".")) > maxLimit) {
      fnSetRangeMessage("Insira um valor entre o Limite Mínimo e o Limite Máximo")
      return
    }
  }

  const handleRangeColorCheck = () => {
    const type = currentField?.opfd_ctype
    if (!getValues(cFieldName)) return ""
    if (type !== "RANGE") return ""
    if (!opfd_nmax_ideal || !opfd_nmin_ideal || !opfd_nmax_limit || !opfd_nmin_limit)
      return ""
    const value = Number(String(getValues(cFieldName))?.replace(",", "."))
    const minIdeal = Number(opfd_nmin_ideal.replace(",", "."))
    const maxIdeal = Number(opfd_nmax_ideal.replace(",", "."))
    const minLimit = Number(opfd_nmin_limit.replace(",", "."))
    const maxLimit = Number(opfd_nmax_limit.replace(",", "."))

    if (value < minLimit || value > maxLimit) return styles.rangeError
    if (
      (value >= minLimit && value <= minIdeal) ||
      (value >= maxIdeal && value <= maxLimit)
    )
      return styles.rangeError
  }

  function fnHandleOnChange(e) {
    const value = e?.target?.value

    const bIsDirty = getValues(cFieldName) === value
    setValue(cFieldName, value, { shouldDirty: !bIsDirty })
    handleCheckRange(value, e)
  }
  const cClass = `${styles.numberField} ${handleRangeColorCheck()} ${
    opfd_csuffix || suffix ? styles.numberFieldSuffix : ""
  }`

  function fnHandleOnBlur(e) {
    const value = e?.target?.value

    /* handleCheckRange(value, e) */
  }
  return (
    <>
      <NumericFormat
        ref={inputRef}
        className={cClass}
        defaultValue={getValues(cFieldName)}
        decimalScale={opfd_nprecision || 0}
        allowLeadingZeros
        fixedDecimalScale
        decimalSeparator=","
        customInput={ElInputNumber}
        onChange={fnHandleOnChange}
        opfd_cprefix={opfd_cprefix}
        prefix={prefix}
        opfd_csuffix={opfd_csuffix}
        suffix={suffix}
        bIsDisabled={bIsEditModel}
        bIsDraggable={bIsDraggable}
        onBlur={fnHandleOnBlur}
        {...oRest}
      />
      {currentField?.opfd_ctype === "RANGE" && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            marginTop: "8px",
          }}
        >
          {rangeMessage && (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "8px 16px",
                border: "1px solid #FF7835",
                backgroundColor: "#FF783514",
                borderRadius: "500px",
                color: "#FF7835",
              }}
            >
              {rangeMessage}
            </span>
          )}
          <div style={{ display: "flex", gap: "8px" }}>
            <span
              style={{
                border: "1px solid #CCD1D6",
                backgroundColor: "#FFF",
                padding: "8px 12px",
                borderRadius: "4px",
                fontWeight: "600",
                color: "#415364",
                fontSize: "14px",
              }}
            >
              Limite Mín.: {opfd_nmin_limit}
            </span>
            <span
              style={{
                border: "1px solid #CCD1D6",
                backgroundColor: "#FFF",
                padding: "8px 12px",
                borderRadius: "4px",
                fontWeight: "600",
                color: "#415364",
                fontSize: "14px",
              }}
            >
              Mín. Ideal: {opfd_nmin_ideal}
            </span>
            <span
              style={{
                border: "1px solid #CCD1D6",
                backgroundColor: "#FFF",
                padding: "8px 12px",
                borderRadius: "4px",
                fontWeight: "600",
                color: "#415364",
                fontSize: "14px",
              }}
            >
              Máx. Ideal: {opfd_nmax_ideal}
            </span>
            <span
              style={{
                border: "1px solid #CCD1D6",
                backgroundColor: "#FFF",
                padding: "8px 12px",
                borderRadius: "4px",
                fontWeight: "600",
                color: "#415364",
                fontSize: "14px",
              }}
            >
              Limite Máx.: {opfd_nmax_limit}
            </span>
          </div>
        </div>
      )}
    </>
  )
})
const RcmpMemoNumberField = React.memo(RcmpNumberField)

const RcmpActivityField = React.forwardRef((props, ref) => {
  const {
    opfd_nid,
    opfd_ctype,
    opfd_cslug,
    ombf_brequired,
    ombf_bautofill,
    ombf_cvalue,
    opfd_cname,
    values,
    oCurrentActivity,
    bIsDraggable = false,
    bIsDisabled = false,
    bIsEditModel = false,
    bIsEdit,
    bCanUnregister = true,
    oActivityFields,
  } = props

  const useFormMethods = useFormContext()
  const {
    getValues,
    setValue,
    register,
    unregister,
    watch,
    formState: { errors },
  } = useFormMethods
  const { oUser } = useContext(AuthContext)
  const { aAllFields } = useContext(FieldsContext)
  const [bIsOpenModalCalcMemory, fnSetBIsOpenModalCalcMemory] = useState(false)
  const cUserTimeZone = oUser?.data?.user_ctimezone
  const cFieldName = `activity-field-${opfd_nid}`
  const [bShowCalcInfoModal, fnSetBShowCalcInfoModal] = useState(false)
  /*   */
  useEffect(() => {
    if (!bCanUnregister) return
    return () => {
      unregister(cFieldName)
    }
  }, [])

  const fnOpenModalCalcMemory = () => fnSetBIsOpenModalCalcMemory(true)
  const fnCloseModalCalcMemory = () => fnSetBIsOpenModalCalcMemory(false)

  if (!opfd_nid) return null

  const oFieldValue = values?.find((v) => v?.opfv_opfd_nid === opfd_nid)

  let cLabel = opfd_cname

  if (bIsEditModel || [dConclusionDateSlug, dCreationDateSlug].includes(opfd_cslug)) {
    cLabel = (
      <div className={styles.requiredTextContainer}>
        <p className={styles.fieldName}>{`${opfd_cname}`} </p>
      </div>
    )
    if (ombf_bautofill) {
      if (opfd_cslug === dConclusionDateSlug) {
        cLabel = (
          <div className={styles.requiredTextContainer}>
            <p className={styles.fieldName}>{intl.get("fields.conclusion_date")} </p>
            <p className={styles.requiredText}>
              ({intl.get("BlocksPage.form.automatic_filling")})
            </p>
          </div>
        )
      }
      if (opfd_cslug === dCreationDateSlug) {
        cLabel = (
          <div className={styles.requiredTextContainer}>
            <p className={styles.fieldName}>{intl.get("fields.creation_date")} </p>
            <p className={styles.requiredText}>
              ({intl.get("BlocksPage.form.automatic_filling")})
            </p>
          </div>
        )
      } else {
        cLabel = (
          <div className={styles.requiredTextContainer}>
            <p className={styles.fieldName}>{`${opfd_cname}`} </p>
            <p className={styles.requiredText}>
              ({intl.get("BlocksPage.form.automatic_filling")})
            </p>
          </div>
        )
      }
    }
  } else if (
    !ombf_bautofill &&
    ![dConclusionDateSlug, dCreationDateSlug].includes(opfd_cslug)
  ) {
    switch (ombf_brequired) {
      case "NOT_REQUIRED":
        cLabel = (
          <div className={styles.requiredTextContainer}>
            <p className={styles.fieldName}>{`${opfd_cname}`} </p>
            <p className={styles.requiredText}>
              ({intl.get("BlocksPage.form.not_required_field")})
            </p>
          </div>
        )
        break
      case "TO_CREATE":
        cLabel = (
          <div className={styles.requiredTextContainer}>
            <p className={styles.fieldName}>{`${opfd_cname}`} </p>
            <p className={styles.requiredText}>
              ({intl.get("BlocksPage.form.required_to_criation")})
            </p>
          </div>
        )
        break
      case "TO_CONCLUDE":
        cLabel = (
          <div className={styles.requiredTextContainer}>
            <p className={styles.fieldName}>{`${opfd_cname}`} </p>
            <p className={styles.requiredText}>
              ({intl.get("BlocksPage.form.required_to_conclusion")})
            </p>
          </div>
        )
        break
    }
  } else if (!bIsEditModel && ombf_bautofill && !bIsEdit) {
    if (opfd_cslug === dConclusionDateSlug) {
      cLabel = (
        <div className={styles.requiredTextContainer}>
          <p className={styles.fieldName}>{intl.get("fields.conclusion_date")} </p>
          <p className={styles.requiredText}>
            ({intl.get("BlocksPage.form.automatic_filling")})
          </p>
        </div>
      )
      intl.get("fields.creation_date")
    }
    if (opfd_cslug === dCreationDateSlug) {
      cLabel = (
        <div className={styles.requiredTextContainer}>
          <p className={styles.fieldName}>{intl.get("fields.conclusion_date")} </p>
          <p className={styles.requiredText}>
            ({intl.get("BlocksPage.form.automatic_filling")})
          </p>
        </div>
      )
    } else {
      cLabel = (
        <div className={styles.requiredTextContainer}>
          <p className={styles.fieldName}>{`${opfd_cname}`} </p>
          <p className={styles.requiredText}>
            ({intl.get("BlocksPage.form.automatic_filling")})
          </p>
        </div>
      )
    }
  }

  if (
    (getValues(cFieldName) === undefined ||
      (!getValues(cFieldName)?.length && opfd_ctype === "DATE")) &&
    oFieldValue?.opfv_cvalue
  ) {
    if (opfd_ctype === "PEOPLES") {
      const aUsersId = oFieldValue?.opfv_cvalue?.map((oUser) => oUser?.user_nid)
      setValue(cFieldName, aUsersId)

      return
    }

    if (opfd_ctype === "SELECTION" && opfd_cslug !== cStatusSlug) {
      setValue(cFieldName, oFieldValue?.selected_option?.opfs_nid)
      return
    }

    if (opfd_ctype === "DATE") {
      //const dFormatedDate = fnFormatDateToUTC(oFieldValue.opfv_cvalue)
      let dFormatedDate = oFieldValue.opfv_cvalue
      if (!oFieldValue?.is_render) {
        dFormatedDate = fnFormatDateFromUTC(
          oFieldValue.opfv_cvalue,
          "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]",
          cUserTimeZone,
        )
      }
      oFieldValue.opfv_cvalue = dFormatedDate
      oFieldValue.is_render = true

      setValue(cFieldName, dFormatedDate)
      return
    }

    setValue(cFieldName, oFieldValue.opfv_cvalue)
    // } else if (Array.isArray(getValues(cFieldName))) {
    //   if (opfd_ctype === "DATE") {
    //     setValue(cFieldName, "")
    //     return
    //   }
  } else {
    if (opfd_ctype === "PEOPLES" && !bIsEdit && !getValues(cFieldName)?.length) {
      setValue(cFieldName, [])
    }
    if (
      opfd_ctype === "PEOPLES" &&
      bIsEdit &&
      !oFieldValue?.opfv_cvalue &&
      !getValues(cFieldName)
    ) {
      setValue(cFieldName, [])
    }

    if (
      opfd_ctype === "SELECTION" &&
      opfd_cslug !== cStatusSlug &&
      !bIsEdit &&
      !getValues(cFieldName)
    ) {
      setValue(cFieldName, null)
    }
    if (
      opfd_ctype === "SELECTION" &&
      opfd_cslug !== cStatusSlug &&
      bIsEdit &&
      oFieldValue?.selected_option === null &&
      !getValues(cFieldName)
    ) {
      setValue(cFieldName, null)
    }

    if (opfd_ctype === "DATE" && !bIsEdit && !getValues(cFieldName)?.length && !bIsEditModel) {
      setValue(cFieldName, "")
    }
  }

  // set status value
  if (opfd_cslug === cStatusSlug && getValues(cStatusFieldName) === undefined) {
    const oOption = oFieldValue?.selected_option
    const cSwitchStatus = oOption?.opfs_coption_name === "Done" ? true : false
    setValue("status", oOption?.opfs_coption_name)
    setValue(cStatusFieldName, cSwitchStatus)
    setValue(cFieldName, oOption?.opfs_nid)
  }

  function fnHandleStatus(bIsChecked) {
    setValue(cStatusFieldName, bIsChecked)
    if (bIsChecked) {
      const oDoneOption = props?.options?.find(
        (oOption) => oOption?.opfs_coption_name === "Done",
      )
      setValue(cFieldName, oDoneOption?.opfs_nid)
      setValue("status", "Done")
      return
    }
    const oPendingOption = props?.options?.find(
      (oOption) => oOption?.opfs_coption_name === "Pending",
    )
    setValue(cFieldName, oPendingOption?.opfs_nid)
    setValue("status", "Pending")
  }

  function fnRenderField() {
    if (opfd_cslug === cDescritionSlug) {
      return (
        <div className={styles.description}>
          <RcmpTextArea
            bIsDraggable={bIsDraggable}
            disabled={bIsDisabled}
            label={cLabel}
            {...register(cFieldName)}
          />
        </div>
      )
    }
    if (opfd_cslug === cStatusSlug) {
      return (
        <>
          {bIsDraggable ? (
            <div className={styles.draggableComponent}>
              <MoveEllipsisIcon />
              <Label className={styles.label}>
                {intl.get("ActivityStatus.activity_status")}
              </Label>
            </div>
          ) : (
            <Label className={styles.label}>
              {intl.get("ActivityStatus.activity_status")}
            </Label>
          )}
          <Label className={styles.statusLabel}></Label>
          <SwitchComponent
            cDisabledText={intl.get("ActivityStatus.pending").toUpperCase()}
            cAbleText={intl.get("ActivityStatus.done").toUpperCase()}
            onChange={fnHandleStatus}
            value={watch(cStatusFieldName)}
            disabled={!oCurrentActivity}
          />
        </>
      )
    }

    // if (opfd_cslug === cDeadLineSlug) { NOT NEEDED, GIVE ERROR WITH TIMEZONE )

    //   return (
    //     <RcmpDeadLineField
    //       ref={ref}
    //       label={cLabel}
    //       required={false}
    //       cFieldName={cFieldName}
    //       bIsEditModel={bIsEditModel}
    //       oFieldValue={oFieldValue}
    //       bIsEdit={bIsEdit}
    //       {...useFormMethods}
    //       {...props}
    //     />
    //   )
    // }

    if (opfd_cslug === dConclusionDateSlug) {
      return (
        <RcmpConclusionDateField
          ref={ref}
          required={false}
          cFieldName={cFieldName}
          cStatusFieldName={cStatusFieldName}
          setValue={setValue}
          oFieldValue={oFieldValue}
          bIsEditModel={bIsEditModel}
          watch={watch}
          cUserTimeZone={cUserTimeZone}
          useFormMethods={useFormMethods}
          cLabel={cLabel}
          bIsDraggable={bIsDraggable}
        />
      )
    }

    if (opfd_cslug === dCreationDateSlug) {
      return (
        <RcmpCreationDateField
          ref={ref}
          ombf_brequired={false}
          cFieldName={cFieldName}
          oFieldValue={oFieldValue}
          bIsEditModel={bIsEditModel}
          bIsDraggable={bIsDraggable}
          bIsEdit={bIsEdit}
          watch={watch}
          setValue={setValue}
          useFormMethods={useFormMethods}
          cLabel={cLabel}
        />
      )
    }
    if (opfd_ctype === "CALC") {
      const fnReturnValue = () => {
        if (getValues(cFieldName)) return getValues(cFieldName)

        return ombf_cvalue || oFieldValue?.opfv_cvalue || "0"
      }

      return (
        <div
          style={{
            display: !bIsEditModel ? "flex" : "initial",
            alignItems: "center",
            flexDirection: "row",
            gap: "6px",
          }}
        >
          <div style={{ flex: 1 }}>
            <CalcField
              bIsEditModel={bIsEditModel}
              aFields={props.aFields}
              cActivityFormula={oFieldValue ? oFieldValue?.opfv_cformula : ""}
              ref={ref}
              label={cLabel}
              value={fnReturnValue()}
              cFieldName={cFieldName}
              setValue={setValue}
              watch={watch}
              activityFieldsValues={getValues()}
              oActivityFields={oActivityFields}
              openShowCalc={() => {
                fnOpenModalCalcMemory()
              }}
              {...useFormMethods}
            />
          </div>

          <ModalCalcMemory
            cFieldName={cFieldName}
            aFields={props}
            cActivityFormula={oFieldValue ? oFieldValue?.opfv_cformula : ""}
            isOpen={bIsOpenModalCalcMemory}
            onClose={fnCloseModalCalcMemory}
          />

          {/* <button
            style={{
              marginTop: "14px",
              backgroundColor: "#6CB6E3",
              padding: "12px 16px",
              borderRadius: "500px",
              minHeight: "32px",
              minWidth: "97px",
              color: "white",
              border: "none",
              fontSize: "14px",
              fontWeight: "600",
            }}
            onClick={(e) => {
              e.preventDefault()
              fnOpenModalCalcMemory()
            }}
          >
            Recalcular
          </button> */}

          {bIsEditModel && (
            <>
              {errors[cFieldName] && (
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "6px 16px",
                    border: "1px solid #FF3541",
                    borderRadius: "500px",
                    fontWeight: "600",
                    fontSize: "14px",
                    color: "#FF3541",
                    marginTop: "8px",
                  }}
                >
                  Revise os valores lançados nos campos de origem!
                </span>
              )}
              <button
                className={styles.linkButton}
                onClick={() => fnSetBShowCalcInfoModal(true)}
              >
                Como fazer cálculos matemáticos
              </button>
              <RmcpModalCalcInfo
                isOpen={bShowCalcInfoModal}
                onClose={() => fnSetBShowCalcInfoModal(false)}
              />
            </>
          )}
        </div>
      )
    }
    if (opfd_ctype === "TEXT") {
      return (
        <RcmpMemoTextField
          ref={ref}
          label={cLabel}
          required={false}
          cFieldName={cFieldName}
          bIsDraggable={bIsDraggable}
          {...useFormMethods}
          {...props}
        />
      )
    }

    if (opfd_ctype === "DATE") {
      return (
        <RcmpDateField
          ref={ref}
          label={cLabel}
          required={false}
          cFieldName={cFieldName}
          bIsEditModel={bIsEditModel}
          bIsDraggable={bIsDraggable}
          oFieldValue={oFieldValue}
          {...useFormMethods}
          {...props}
        />
      )
    }

    if (opfd_ctype === "SELECTION") {
      return (
        <RcmpSelectionField
          ref={ref}
          label={cLabel}
          required={false}
          cFieldName={cFieldName}
          oFieldValue={oFieldValue}
          bIsDraggable={bIsDraggable}
          getValues={getValues}
          {...useFormMethods}
          {...props}
        />
      )
    }

    if (opfd_ctype === "PEOPLES") {
      return (
        <RcmpPeoplesField
          bIsDraggable={bIsDraggable}
          ref={ref}
          label={cLabel}
          required={false}
          cFieldName={cFieldName}
          oFieldValue={oFieldValue}
          disabled={bIsDisabled}
          getValues={getValues}
          {...useFormMethods}
          {...props}
        />
      )
    }

    if (opfd_ctype === "NUMBER" || opfd_ctype === "RANGE") {
      return (
        <>
          <RcmpMemoNumberField
            ref={ref}
            label={cLabel}
            required={false}
            bIsDraggable={bIsDraggable}
            cFieldName={cFieldName}
            oFieldValue={oFieldValue}
            bIsEditModel={bIsEditModel}
            currentField={aAllFields.find((field) => field.opfd_nid === opfd_nid)}
            {...useFormMethods}
            {...props}
          />
        </>
      )
    }

    return null
  }

  return (
    <div className={styles.fieldContainer}>
      {fnRenderField()}

      {opfd_ctype?.toLowerCase() !== "range" && (
        <RcmpFormErrorMessage>{errors[cFieldName]?.message}</RcmpFormErrorMessage>
      )}
    </div>
  )
})

function RmcpModalCalcInfo(props) {
  const { isOpen, onClose } = props
  return (
    <Modal isOpen={isOpen} size="md">
      <Modal.Header onClose={onClose}>Como fazer cálculos matemáticos</Modal.Header>
      <Modal.Content
        size="md"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          flex: "1",
          padding: "0% 10%",
          gap: "1rem",
        }}
      >
        <span
          style={{
            color: "#3B454F",
            fontWeight: "600",
            fontSize: "14px",
            lineHeight: "21px",
          }}
        >
          Para escolher os Campos Numéricos que serão utilizados em cálculos, simplesmente
          insira o nome dos correspondentes.
        </span>
        <span
          style={{
            color: "#3B454F",
            fontWeight: "600",
            fontSize: "14px",
            lineHeight: "21px",
          }}
        >
          Quanto à seleção das operações matemáticas desejadas, basta inserir o símbolo
          correspondente no teclado.
        </span>
      </Modal.Content>
      <Modal.Footer>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",

            width: "100%",
          }}
        >
          <Button variant="outline" onClick={onClose}>
            Fechar
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default RcmpActivityField
